export default __webpack_public_path__ + "static/media/goopter-own-your-online-brand.65b1c93f.jpg";